import React from 'react';
import Proptypes from 'prop-types';
import { Bar } from './Styles';

const propTypes = {
  width: Proptypes.string,
  height: Proptypes.string,
  margin: Proptypes.string,
  borderRadius: Proptypes.string,
  speedMultiplier: Proptypes.number
};

// these are the same defaults as the react-spinners package
const defaultProps = {
  width: '4px',
  height: '35px',
  margin: '2px',
  borderRadius: '2px',
  speedMultiplier: 1
};

const ScaleLoader = props => (
  <span data-testid="scale_loader">
    <Bar position={1} {...props} />
    <Bar position={2} {...props} />
    <Bar position={3} {...props} />
    <Bar position={4} {...props} />
    <Bar position={5} {...props} />
  </span>
);

ScaleLoader.propTypes = propTypes;
ScaleLoader.defaultProps = defaultProps;

export default ScaleLoader;
